export function getMetaContent(name: string): string | null {
  const element = document.querySelector(`meta[name="${name}"]`)
  return element?.getAttribute("content") || null
}
